function packageData(overLoad,value) {
  return {
    isOverLoad : overLoad,
    avgValue : value
  }
}

module.exports = packageData